const daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

module.exports = {
  daysOfWeek,
};



/** WEBPACK FOOTER **
 ** ./src/config/availability.js
 **/